module.exports = __webpack_public_path__ + "static/media/lion-4.b52af33e.jpg";